<template>
    <div class="form">
        <div class="fields">
            <component
                :maskMoney="field.maskMoney"
                :title="field.title"
                :maskFormat="field.maskFormat"
                v-show="!field.hideInput"
                :disabled="field.disabled"
                :valueField="field.valueField"
                :keyValue="field.keyValue"
                :keyName="field.keyName"
                :options="field.options"
                :items="field.items"
                :rules="field.rules"
                :label="field.label"
                :placeholder="field.placeholder"
                :cols="isMobile ? '12' : field.cols"
                v-for="(field, index) in fields"
                :key="field.fieldType+index"
                :is="field.fieldType"
                :type="field.type"
                @onEnter="inputsValues[field.variableName] = $event, $emit('update:values', inputsValues), $emit('save')"
                @update:value="inputsValues[field.variableName] = $event, $emit('update:values', inputsValues)"
            />
        </div>
    </div>
</template>

<script>
    import TextField from "./inputs/TextField";
    import SelectField from "./inputs/SelectField";
    import ImageField from "./inputs/ImageField";
    import TextAreaField from "./inputs/TextAreaField";
    import TextFieldMask from "./inputs/TextFieldMask";
    import TextFieldMoney from "./inputs/TextFieldMoney";
    import HeaderLabel from "./inputs/HeaderLabel";
    import ColorField from "./inputs/ColorField";
    import ToggleToken from "./inputs/ToggleToken";
    import MultipleImagesField from "./inputs/MultipleImagesField";
    import Vue from 'vue';

    export default {
        name: "FormFields",
        components:{
            TextField,
            SelectField,
            ImageField,
            TextAreaField,
            TextFieldMask,
            TextFieldMoney,
            HeaderLabel,
            ColorField,
            MultipleImagesField,
            ToggleToken
        },
        props:[
            'fields',
            'validate',
            'codRef'
        ],
        data(){
            return{
                windowWidth: window.innerWidth,
                inputsValues:{},
                formRef: false,
            }
        },
        watch:{
            fields(){
                this.fields.forEach( (field) => {
                    Vue.set(this.inputsValues, field.variableName, '');
                });
            },
            validate(){
                if (this.$refs[this.formRef].validate() !== false) {
                    this.$emit('save',this.$refs[this.formRef].validate());
                }
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth
            })
            this.formRef = (this.formRef ? this.formRef : 'form');
        },
        computed: {
            isMobile() {
                return this.windowWidth <= 768;
            }
        },
        created() {
          this.$root.$refs.FormFields = this;
        }

    }
</script>

<style scoped>
    .form{
        width: 100%;
        z-index: 3;
    }
    .fields{
        display: flex;
        flex-wrap: wrap;
        align-content: stretch;
        align-items: center;
        flex: 1;
    }
</style>
